import { render, staticRenderFns } from "./InformacoesEsterilizacaoLote.vue?vue&type=template&id=5f5386e8&scoped=true&"
import script from "./InformacoesEsterilizacaoLote.vue?vue&type=script&lang=js&"
export * from "./InformacoesEsterilizacaoLote.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesEsterilizacaoLote.vue?vue&type=style&index=0&id=5f5386e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5386e8",
  null
  
)

export default component.exports